import api from '@/helpers/api'

const API_READ=`/api/point_plan/`
const API_UPDATE=API_READ
const API_CREATE=API_READ
const API_DELETE=API_READ

export default {
  namespaced:true,
  state: {
    status: '',
    pointplans:[],
    currUser: {},
    errMessage: '',
    meta:{
        page:1,
        limit:10,
        total:1
    },
    filter: {},
    search: {}
  },
  mutations: {
    request(state){
        state.status = 'loading'
    },
    success(state){
        state.status = 'success'
    },
    error(state){
        state.status = 'error'
    },
    read(state, {pointplans}){
        state.pointplans = [...pointplans]
    },
    read_single_success(state, {pointplans}){
        state.pointplans = pointplans
    },
    switch_page(state,{meta}){
        state.meta={...meta}
    },
    add_filter(state, {filter}) {
        state.filter = {...filter};
    },
    set_search(state, {search}){
        state.search = {...search};
    },
    clear_search(state){
        state.search = {};
    },
    clear_filter(state) {
        state.filter = {};
    },
  },
  actions: {
    read({commit, state}){
        
        commit('request');
        
        const {meta} = state
        const {filter} = state
        const {search} = state

        return new Promise((resolve, reject) => {
            api.request('get', API_READ, {meta, filter, search})
            .then((result) => {
                commit('success')
                commit('read',{pointplans:result.data.data})
                commit('switch_page',{meta:{...result.data.meta}})
                return resolve()
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err);
            });
        });
    },
    read_single({commit},id){

        commit('request');

        return new Promise((resovle, reject) => {
            api.request('get', `${API_READ}${id}`)
            .then((result) => {            
                commit('success')
                return resovle(result.data.data);
            }).catch((err) => {
                commit('error', {message: err});
                return reject(err)
            });
        });
    },
    read_single_plan({commit},id){

        commit('request');

        return new Promise((resovle, reject) => {
            api.request('get', `${API_READ}plan/${id}`)
            .then((result) => {            
                commit('success')
                return resovle(result.data.data);
            }).catch((err) => {
                commit('error', {message: err});
                return reject(err)
            });
        });
    },
    delete({commit,dispatch},id){

        commit('request');
        
        return new Promise((resolve, reject) => {
            api.request('delete', `${API_DELETE}${id}`)
            .then((response) => {
                dispatch('read');
                commit('success');
                return resolve(response.data)
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err.response.data)
            });
        })
    },
    update({commit},{data}){

        commit('request');
        
        return new Promise((resolve, reject) => {
            
            data.price = data.price.split('.').join("");

            api.request('put', `${API_UPDATE}${data.id}`, {}, data)
            .then((request) => {
                commit('success');
                return resolve(request)
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err)
            });
        });
    },
    create({commit},{data}){
        
        commit('request');

        return new Promise((resolve, reject) => {
            api.request('post', API_CREATE, {}, data)
            .then((request) => {
                commit('success');
                return resolve(request)
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err)    
            });
        });
    },
    },
    getters: {
        pointplans: () => state => state.pointplans,
    }
}
